import { useContext } from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';

import { NOOP } from '@lootboy/lib/utils';

import BottomPopupButton, { SIDES } from '~/components/BottomPopupButton';
import { CookieConsentsContext } from '~/components/CookieConsentsProvider';

import { ECookieProcessingServices } from '~/constants/cmp';

import styles from './Footer.module.scss';

export default function Footer({ discordUrl }) {
  const { acceptService } = useContext(CookieConsentsContext);

  return (
    <div className={styles.footer}>
      <BottomPopupButton
        side={SIDES.RIGHT}
        className={styles.button}
        divider
        dividerClassName={styles.divider}
        onClick={() => {
          if (discordUrl) {
            acceptService(ECookieProcessingServices.DISCORD)
              .then(() => {
                window.open(discordUrl, '_self');
              })
              .catch(NOOP);
          }
        }}
      >
        {I18n.t('common_okay')}
      </BottomPopupButton>
    </div>
  );
}

Footer.propTypes = {
  discordUrl: string,
};
